//export const BASE_URL = "http://entrecopas-laravel8.test";
export const BASE_URL = "https://admin.entrecopas.com.mx";
export const API_URL = `${BASE_URL}/api`;
export const WEBSITE = "https://entrecopas.com.mx";